import React, { useEffect, useState } from "react";
import DataContext from "../../context/DataContext";
import { useContext } from "react";
import ReactModal from "react-modal";
import CloseButton from "../../Images/CloseButton.svg";
import { getCategoryNames } from "../../api/lib/templates";

const TemplateDetailDisplayModal = ({
  showTemplateModal,
  setShowTemplateModal,
}) => {
  const { templateDetail } = useContext(DataContext);
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getCategoryNames();
        const categoriesData = data?.data.data;
        console.log(categoriesData, "categories-response");
        if (Array.isArray(categoriesData)) {
          setCategories(categoriesData);
        } else {
          console.log("Invalid category data:", categoriesData);
        }
      } catch (error) {
        console.log("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);
  const categoryName =
    categories?.find((c) => c._id === templateDetail?.categoryId)?.name || "N/A";

  return (
    <ReactModal
      className="view-template-modal"
      isOpen={showTemplateModal}
      onRequestClose={() => setShowTemplateModal(false)}
      ariaHideApp={false}
    >
      <div className="view-template-body" key={templateDetail._id}>
        <div className="view-template-header">
          <div className="view-template-heading">Template Details</div>
          <img
            src={CloseButton}
            alt="Close"
            style={{ cursor: "pointer" }}
            className="view-template-closebutton"
            onClick={() => setShowTemplateModal(false)}
          />
        </div>
        <hr className="view-template-hr" />
        <div className="view-template-content-body">
          <div className="view-template-leftwrap">
            <video
              src={templateDetail?.videoTemplate?.url}
              controls
              className="view-template-video"
            />
          </div>
          <div className="view-template-rightwrap">
            <div className="view-template-right-content">
              <div className="view-template-wrap">
                <div className="view-template-modal-heading">Title</div>
                <div className="view-template-title-content">
                  {templateDetail?.name}
                </div>
              </div>
              <div className="view-template-wrap">
                <div className="view-template-modal-heading">Category</div>
                <div className="view-template-title-content">
                  {categoryName}
                </div>
              </div>
              <div className="view-template-wrap">
                <div className="view-template-modal-heading">Suitable For</div>
                <div className="view-template-suitable-content">
                  {templateDetail?.suitableFor}
                </div>
              </div>
              <div className="view-template-wrap">
                <div className="view-template-modal-heading">Description</div>
                <div className="view-description-content">
                  {templateDetail?.description}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default TemplateDetailDisplayModal;
